<ng-template #template>
  <td class="text-center">
    <!-- READ -->
    <app-permission-verb-toggle
      [verb]="PermissionVerb.Read"
      [all]="all.r"
      [any]="any.r"
      [recursive]="rec"
      [children]="chl"
      [childrenKnown]="chlKnown"
      [childrenAll]="chlAll?.r"
      [childrenAny]="chlAny?.r"
      [disabled]="disabled"
      [protect]="protect && all.r"
      (change)="change.emit($event)"
    >
    </app-permission-verb-toggle>
  </td>
  <td class="text-center">
    <!-- WRITE -->
    <app-permission-verb-toggle
      [verb]="PermissionVerb.Write"
      [all]="all.w"
      [any]="any.w"
      [recursive]="rec"
      [children]="chl"
      [childrenKnown]="chlKnown"
      [childrenAll]="chlAll?.w"
      [childrenAny]="chlAny?.w"
      [disabled]="disabled"
      [protect]="protect && all.w"
      (change)="change.emit($event)"
    >
    </app-permission-verb-toggle>
  </td>
  <td class="text-center">
    <!-- DELETE -->
    <app-permission-verb-toggle
      [verb]="PermissionVerb.Delete"
      [all]="all.d"
      [any]="any.d"
      [recursive]="rec"
      [children]="chl"
      [childrenKnown]="chlKnown"
      [childrenAll]="chlAll?.d"
      [childrenAny]="chlAny?.d"
      [disabled]="disabled"
      [protect]="protect && all.d"
      (change)="change.emit($event)"
    >
    </app-permission-verb-toggle>
  </td>
</ng-template>
